import {
  type IModalDeleteConfirmWordingProps,
  type IModalDeleteWordingProps,
  ModalDelete,
  ModalDeleteConfirm,
} from './components';
import { useModalDelete } from './hooks';

interface IModalDeleteWrapperProps {
  openModal: boolean;
  onClose: () => void;
  onDelete: () => Promise<void> | void;
  refetch?: () => void;
  modalDeleteWording: IModalDeleteWordingProps;
  modalDeleteConfirmWording: IModalDeleteConfirmWordingProps;
  noValidation?: boolean;
}

const ModalDeleteWrapper: React.FC<IModalDeleteWrapperProps> = ({
  openModal,
  onDelete,
  onClose,
  refetch,
  modalDeleteWording,
  modalDeleteConfirmWording,
  noValidation,
}) => {
  const {
    openModalDelete,
    openModalDeleteConfirm,
    onCloseModalDelete,
    onCloseModalDeleteConfirm,
    disabledModalDelete,
    onConfirmModalDelete,
    onConfirmModalDeleteConfirm,
    textConfirmation,
    textToConfirm,
    setTextConfirmation,
  } = useModalDelete({
    open: openModal,
    onClose,
    onDelete,
    refetch,
    noValidation,
  });

  return (
    <>
      <ModalDelete
        value={textConfirmation}
        isOpen={openModalDelete}
        onClose={onCloseModalDelete}
        textToConfirm={textToConfirm}
        disabled={disabledModalDelete}
        onConfirm={onConfirmModalDelete}
        setTextConfirmation={setTextConfirmation}
        {...modalDeleteWording}
      />
      <ModalDeleteConfirm
        isOpen={openModalDeleteConfirm}
        onClose={onCloseModalDeleteConfirm}
        onConfirm={onConfirmModalDeleteConfirm}
        {...modalDeleteConfirmWording}
      />
    </>
  );
};
export default ModalDeleteWrapper;
